/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_StartInputs */

const en_mk_foot_start = /** @type {(inputs: Mk_Foot_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started`)
};

const id_mk_foot_start = /** @type {(inputs: Mk_Foot_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai`)
};

/**
* | output |
* | --- |
* | "Get started" |
*
* @param {Mk_Foot_StartInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_start = /** @type {((inputs?: Mk_Foot_StartInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_StartInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_start(inputs)
	return en_mk_foot_start(inputs)
});